import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const Mission = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('mission.bannerTitle')}
                path="/about-us"
            />

            <div className="about-us-page">
                {/* Misyon Bölümü */}
                <div className="about-vm-section">
                    <div className="container">
                        <div className="about-vm-row reverse mb-5">
                            <div className="about-vm-content">
                                <span className="about-vm-badge">{t('aboutUs.mission.badge')}</span>
                                <h2 className="about-vm-title">{t('aboutUs.mission.title')}</h2>
                                <p className="about-vm-text">{t('aboutUs.mission.desc')}</p>
                            </div>
                            <div className="about-vm-image">
                                <img src="/assets/images/new-img/misyon.png" alt="Misyon" />
                            </div>
                        </div>
                    </div>
                </div>

                <Cta1
                    title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}
                />
            </div>
        </div>
    );
};

export default Mission;
